import React, { useState } from "react";
import { MenuCustom } from "../../../components/commons/menuCustom/menuCustom";
import CardCustom from "../../../components/card";
import { Box, Card, Grid, IconButton } from "@mui/material";
import { ProfileSetting } from "./profileSettings/profileSetting";
import { EnterpriseSettings } from "./enterpriseSettings/enterpriseSettings";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import StoreIcon from "@mui/icons-material/Store";
import BusinessIcon from "@mui/icons-material/Business";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import { Setting } from "./setting/setting";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const UserSetting = ({ data, stateSelect, onDeleted }: any) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const menu = [
    {
      icon: <AccountCircleIcon />,
      title: "Perfil",
      key: 0,
    },
    {
      icon: <BusinessIcon />,
      title: "Empresa",
      key: 1,
    },
    {
      icon: <SettingsSuggestIcon />,
      title: "Configuraciónes",
      key: 2,
    },
  ];


  const caseMenu: any = () => {
    switch (selectedIndex) {
      case 0:
        return <ProfileSetting data={data} />;

      case 1:
        return <EnterpriseSettings data={data} />;

      case 2:
        return <Setting data={data} onDeleted={onDeleted} />;

      default:
        break;
    }
  };

  const dinamicTitle: any = () => {
    switch (selectedIndex) {
      case 0:
        return (
          <>
            <h2>Perfil</h2>
            <p>
              Administra la información personal de los usuarios registrados.
              Aquí puedes ver detalles como nombre, correo electrónico y roles
              asignados, además de realizar actualizaciones específicas en sus
              perfiles.
            </p>
          </>
        );

      case 1:
        return (
          <>
            <h2>Empresa</h2>
            <p>
              Gestiona la información relacionada con las empresas vinculadas a
              los usuarios registrados. Puedes actualizar datos corporativos,
              asociar usuarios a empresas específicas y configurar permisos
              basados en roles empresariales.
            </p>
          </>
        );

      case 2:
        return (
          <>
            <h2>Configuración</h2>
            <p>
              Ajusta los parámetros generales para la gestión de usuarios
              registrados. Define roles, permisos y políticas de seguridad para
              garantizar un acceso controlado y eficiente a las funcionalidades
              de la plataforma.
            </p>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div>
      <Box sx={{ padding: "10px" }}>
        <IconButton aria-label="delete" size="small" onClick={()=> {stateSelect(null)}}>
          <ArrowBackIcon />
        </IconButton>
        {dinamicTitle()}
      </Box>

      <Grid container spacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={2}>
          <MenuCustom
            setSelectedIndex={setSelectedIndex}
            selectedIndex={selectedIndex}
            menuItems={menu}
          />
        </Grid>
        <Grid item xs={8}>
          {caseMenu()}
        </Grid>
      </Grid>
    </div>
  );
};
